import { AuthUser, AuthConfig, AuthService } from './../../../Services/auth.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Artist } from 'src/app/Services/artists.service';
import { ResponseObject } from 'src/app/Services/auth.service';
import { ConnectedNote, ConnectedNotesService } from 'src/app/Services/connected-notes.service';
import { ConnectedGallery } from 'src/app/Services/connections.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { NotificationTypes } from 'src/app/app.enums';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'connectedartists-notes', // Component selector for the HTML template
    templateUrl: './connectedartists-notes.component.html',
    standalone: false
})
export class ConnectedartistsNotesComponent implements OnInit {
    @Input() connectartist!: Artist; // Input property for the selected artist
    @Input() connectGallery?: ConnectedGallery; // Optional input property for the connected gallery
    @Input() notesDialogVisible: boolean = false; // Input property to control the visibility of the notes dialog
    @Output() onCloseDialog = new EventEmitter<boolean>(); // Output event emitter for closing the dialog
    public newNoteText: string | null = null; // New note text to be added
    public notes: ConnectedNote[] = []; // Array to store connected notes
    public displayEmojiDialog: boolean = false; // Boolean to control the visibility of the emoji dialog
    public authUser: AuthUser | null = null;
    public isArtist: boolean = false;
    public isGallery: boolean = false;
    public galleryId!: string;
    public isAuthenticated: boolean = false;
    public authConfig!: AuthConfig;

    constructor(
        private ngxSpinnerService: NgxSpinnerService,
        private notificationService: NotificationsService,
        private connectedNotesService: ConnectedNotesService,
        private authService: AuthService,
        private transloco: TranslocoService,
    ) { }

    ngOnInit(): void {
        this.isAuthenticated = this.authService.isAuthenticated();

        if (this.isAuthenticated) {
            this.authConfig = this.authService.getAuthConfig();
            this.authUser = this.authService.getCurrentUser();

            // Update flags based on authConfig
            this.isArtist = this.authConfig.IsArtist || false;
            this.isGallery = this.authConfig.IsGallery || false;

            if (this.authUser) {
                this.galleryId = this.authUser.UserId;
            }
        }
        if (this.connectartist && this.connectartist.Id) {
            this.getConnectedNotes(this.connectartist.Id); // Fetch connected notes on initialization
        }
    }

    private getConnectedNotes(artistId: string | null) {
        if (!artistId) {
            console.error('Artist ID is null or undefined');
            return;
        }

        this.ngxSpinnerService.show();
        this.connectedNotesService.getConnectedNotes(artistId, null).subscribe(
            (response) => {
                this.ngxSpinnerService.hide();
                if (response) {
                    if(this.isGallery){
                     this.notes = response.filter(notes=>notes.CommentsBy == this.galleryId);
                     console.log('for gallery', this.notes);
                    }
                 }
            },
            (error) => {
                console.error(error);
                this.ngxSpinnerService.hide();
            }
        );
    }

    public openNotesDialog(artist: Artist) {
        this.newNoteText = null;
        this.connectartist = artist;
        this.notesDialogVisible = true;
        if (artist.Id) {
            this.getConnectedNotes(artist.Id); // Fetch connected notes when opening the dialog
        }
    }

    public saveNotes() {
        if (!this.newNoteText || !this.connectartist || !this.connectartist.Id) return;

        this.ngxSpinnerService.show();
        this.connectedNotesService
            .saveConnectedNotes(this.connectartist.Id, null, this.newNoteText)
            .subscribe(
                (response: ResponseObject) => {
                    this.ngxSpinnerService.hide();
                    if (response.Success) {
                        this.newNoteText = null;
                        // Refresh the connected artist notes on the dialog
                        if (this.connectartist.Id) {
                            this.getConnectedNotes(this.connectartist.Id);
                        }
                        this.notificationService.showNotification(
                            this.transloco.translate('connectedartistsNotes.success'),
                            this.transloco.translate('connectedartistsNotes.changesSaved'),
                            NotificationTypes.Success
                        );
                    } else {
                        this.notificationService.showNotification(
                            this.transloco.translate('connectedartistsNotes.error'),
                            response.ResponseMessage,
                            NotificationTypes.Error
                        );
                    }
                },
                (error) => {
                    console.error(error);
                    this.ngxSpinnerService.hide();
                }
            );
    }

    // Method to close the notes dialog
    public closeNotesDialog() {
        this.notesDialogVisible = false;
        this.onCloseDialog.emit(this.notesDialogVisible);
    }

    // Method to toggle the emoji dialog visibility
    public openEmojiDialog() {
        this.displayEmojiDialog = !this.displayEmojiDialog;
    }

    // Method to add the selected emoji to the note text
    public addEmoji(emoji: string) {
        console.log('Selected emoji:', emoji);
        this.newNoteText = (this.newNoteText || '') + emoji; // Append the selected emoji to the note text
        this.displayEmojiDialog = false; // Close the emoji dialog
    }

    // Method to close the emoji dialog
    public closeEmojiDialog($event: any) {
        this.displayEmojiDialog = false;
    }
}
